module.exports = __webpack_public_path__ + "static/media/author-3.e689a25f.jpg";